import DictionaryForm from '@/modules/Dictionary/__form';
import {
  setItemName,
  setItemNameLat,
  setItemCode,
} from '@/modules/Dictionary/__form/item';
import FDictionaryService from '@/modules/Dictionary/Service/Select';

export default class DictionaryServiceDescription2Form extends DictionaryForm {
  static permission = {
    add: [114],
    edit: [348],
    view: [115],
    remove: [349],
  };

  dictionary = 'addDescription2';

  constructor(props = {}) {
    super(props);
    this.setItemService();
    setItemName.bind(this)({ length: 50 });
    setItemNameLat.bind(this)({ length: 50 });
    setItemCode.bind(this)();
  }

  setItemService() {
    this.service = new FDictionaryService({
      name: 'ServiceClassId',
      show: false,
    });
    this.setItem('service', this.service);
  }
}
